import { IComponentOptions } from "angular";
import { MainMachinesGatewayComponentController as MainMachineViewGatewayComponentController } from "./controller";

export const vsComponentName = "mainMachineViewGateway";

export const mainMachinesGatewayComponentOptions: IComponentOptions = {
  controller: MainMachineViewGatewayComponentController,
  controllerAs: "mainMachineViewGatewayController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    reportGroup: "<",
    gridConfiguration: "<",
  },
};
